module.exports = __webpack_public_path__ + "static/media/DTSA-2022-LOGO.c57a3126.png";